import React, { useState, useEffect } from 'react';
import valid from 'card-validator';
import icon from '/fallbacks/lock-2.svg';
import { useMask } from '@react-input/mask';

const CardField = ({ placeholder, error, name, width, value, margin, max, handleChange }) => {
	const [isFocused, setIsFocused] = useState(false);
	const [creditCardType, setCardType] = useState(null);
	useEffect(() => {
		const cardData = valid.number(value);
		if (cardData?.card?.type) {
			setCardType(cardData?.card?.type);
		} else {
			setCardType(null);
		}
	}, [value]);

	const cardRef = useMask({ mask: '____ ____ ____ ____', replacement: { _: /\d/ } });

	return (
		<div
			className="input-container"
			style={{
				width: width == 'full' ? '100%' : `calc(${width == 'half' ? 50 : width}% - 6px)`,
				marginRight: margin ? '12px' : '0px',
				backgroundColor: 'transparent',
			}}
		>
			<div className={`input input--text ${error && 'input--error'}`}>
				<input
					maxLength={max}
					className="styledInput"
					autoComplete="cc-number"
					type="tel"
					name={name}
					ref={cardRef}
					onChange={handleChange}
					value={value}
					onBlur={() => {
						setIsFocused(false);
					}}
					onFocus={() => {
						setIsFocused(true);
					}}
				/>
				<label className={isFocused || value.length > 0 ? 'styledLabel styledLabel--active' : 'styledLabel'}>
					{placeholder}
				</label>
				<div
					className="input__img"
					style={{
						width: creditCardType ? '24px' : '16px',
						height: creditCardType ? '24px' : '16px',
						backgroundSize: 'contain',
						backgroundImage: `url(${
							creditCardType
								? window.template_root +
									'/templates/checkout-pages/V3/src/public/cards/' +
									creditCardType +
									'.svg'
								: icon
						})`,
					}}
				></div>
			</div>
			{error && <span className="formError">{error}</span>}
		</div>
	);
};

export default CardField;
